export default __webpack_public_path__ + "static/media/bydgosz.8113de57.jpg";